import { Component, input, linkedSignal, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CONSENT_REJECT, Consent, DEFAULT_CONSENT } from '@navfleet/client/cookie-consent/domain/models';
import { TranslationModule } from '@navfleet/shared/core/translation';
import { Button } from '@openng/optimus-ui/button';
import { CheckboxModule } from '@openng/optimus-ui/checkbox';
import { Dialog } from '@openng/optimus-ui/dialog';

@Component({
    imports: [FormsModule, CheckboxModule, TranslationModule, Dialog, Button],
    selector: 'fl-cookie-consent-dialog',
    templateUrl: './cookie-consent-dialog.component.html',
    styleUrls: ['./cookie-consent-dialog.component.scss'],
})
export class CookieConsentDialogComponent {
    public readonly consent = input<Consent>();
    public readonly show = input<boolean>(false);
    public readonly save = output<Consent>();

    public readonly consentModel = linkedSignal<Consent>(() => ({ ...(this.consent() ?? DEFAULT_CONSENT) }));

    public acceptAll(): void {
        this.save.emit(DEFAULT_CONSENT);
    }

    public acceptSelected(): void {
        this.save.emit(this.consentModel());
    }

    public reject(): void {
        this.save.emit(CONSENT_REJECT);
    }
}
